"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class HistoryIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                React.createElement("g", null,
                    React.createElement("g", { transform: "translate(6.000000, 4.000000)" },
                        React.createElement("path", { d: "M0,0.96 C0,0.42975 0.42975,0 0.96,0 L8,0 L12,3.36 L12,15.04 C12,15.57 11.57025,16 11.04,16 L0.96,16 C0.42975,16 0,15.57 0,15.04 L0,0.96 Z", fill: "#FFFFFF" }),
                        React.createElement("path", { d: "M8,0 L8,2.4 C8,2.93025 8.42975,3.36 8.96,3.36 L12,3.36", fill: fill, opacity: "0.48999998" }),
                        React.createElement("rect", { fill: fill, x: "2.4", y: "2.4", width: "3.2", height: "1" }),
                        React.createElement("rect", { fill: fill, x: "2.4", y: "7.2", width: "7.2", height: "1" }),
                        React.createElement("rect", { fill: fill, x: "2.4", y: "8.8", width: "7.2", height: "1" }),
                        React.createElement("rect", { fill: fill, x: "2.4", y: "10.4", width: "7.2", height: "1" }),
                        React.createElement("rect", { fill: fill, x: "2.4", y: "12", width: "7.2", height: "1" }))))));
    }
}
exports.HistoryIcon = HistoryIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/history.tsx
// module id = 2147
// module chunks = 0 1 2